import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then(async () => {
        const shouldOpenInstall = new URLSearchParams(window.location.search).get('install') === '1';
        const hasReloadedForInstall = sessionStorage.getItem('pwa-install-reload') === '1';

        if (shouldOpenInstall && !navigator.serviceWorker.controller && !hasReloadedForInstall) {
          sessionStorage.setItem('pwa-install-reload', '1');
          await navigator.serviceWorker.ready;
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error('Service worker registration failed:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
